import React, { useEffect, useMemo } from 'react';
import { debounce } from 'lodash';
import { useResizeObserver } from 'usehooks-ts';
import type { SurfData } from 'types/surf';
import useSetupSurfGraphCanvas from '../../hooks/useSetupSurfGraphCanvas';

import styles from './GraphSurf.module.scss';

interface GraphSurfProps {
  activeHour?: number;
  data: SurfData;
  day: number;
  dayIndex?: number;
  isMobile: boolean;
}

const GraphSurf: React.FC<GraphSurfProps> = ({ activeHour, data, day, dayIndex, isMobile }) => {
  const canvasRef = React.useRef<HTMLDivElement | null>(null);

  const { height: graphHeight = 150, width: graphWidth = 320 } = useResizeObserver({
    ref: canvasRef,
  });

  const { setupGraph } = useSetupSurfGraphCanvas({
    activeHour,
    data,
    day,
    dayIndex,
    graphHeight,
    graphWidth,
    isMobile,
  });

  const debouncedSetupGraph = useMemo(
    () => debounce(setupGraph, 100, { leading: true, trailing: true }),
    [setupGraph],
  );

  useEffect(() => {
    if (graphWidth) debouncedSetupGraph();

    return () => {
      debouncedSetupGraph.cancel();
    };
  }, [graphWidth, debouncedSetupGraph]);

  return (
    <div className={styles.graphSurfHeight} ref={canvasRef} data-testid={`graph-surf-${day}`}>
      <div id={`surf-graph-canvas-day-${day}`} />
    </div>
  );
};

export default GraphSurf;
